import { render, staticRenderFns } from "./OemDefectiveList.vue?vue&type=template&id=281f5a79&scoped=true&"
import script from "./OemDefectiveList.vue?vue&type=script&lang=js&"
export * from "./OemDefectiveList.vue?vue&type=script&lang=js&"
import style0 from "./OemDefectiveList.vue?vue&type=style&index=0&id=281f5a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f5a79",
  null
  
)

export default component.exports